import React, { CSSProperties, HTMLAttributes } from "react";
import loadingImage from "../../../images/loading.svg";
import styles from "./MGLoader.module.css";

export const MGLoaderColor = {
  brand: "brand",
  dark: "dark",
} as const;

export type TMGLoaderColor = keyof typeof MGLoaderColor;

export type TMGLoaderProps = Omit<HTMLAttributes<HTMLDivElement>, "children" | "color"> & {
  color?: TMGLoaderColor;
  dataTestId?: string;
  label?: string;
  size?: number;
};

type TMGLoaderStyle = CSSProperties & {
  "--mg-loader-image": string;
  "--mg-loader-size": string;
};

export const MGLoader = ({
  color = "brand",
  dataTestId,
  label = "A carregar",
  size = 80,
  className,
  role = "status",
  style,
  "aria-label": ariaLabel,
  ...htmlProps
}: TMGLoaderProps) => {
  const loaderStyle: TMGLoaderStyle = {
    "--mg-loader-image": `url(${JSON.stringify(loadingImage)})`,
    "--mg-loader-size": `${size}px`,
    ...style,
  };

  return (
    <div
      {...htmlProps}
      role={role}
      aria-label={ariaLabel ?? label}
      aria-live="polite"
      aria-busy="true"
      className={`${styles.loader}${className ? ` ${className}` : ""}`}
      data-color={color}
      data-testid={dataTestId}
      style={loaderStyle}>
      <span className={styles.spinner} aria-hidden="true" />
    </div>
  );
};
